import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';

@Injectable()
export class SaleSampleService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private sampleUrl  = 'api/sample';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getSampleList(userData: any): Promise<any[]> {
    
        const url = `${this.sampleUrl}/getSampleList`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    
    getAutoNumber(userData: any): Promise<any[]> {
       
        const url = `${this.sampleUrl}/getAutoNumber`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

       save(userData: any): Promise<any[]> {
         console.log(userData);
        const url = `${this.sampleUrl}/save`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getSampleGridList(userData: any): Promise<any[]> {
    
        const url = `${this.sampleUrl}/getSampleGridList`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

     delete(userData: any): Promise<any[]> {
    
        const url = `${this.sampleUrl}/delete`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
  
    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/salesample.service.ts